import { useEffect, useRef, useState } from 'react'

import { orders } from '../api/services/orders'
import { OrderDetailsType } from '../api/services/orders/types.ts'

export const useOrderDetails = (orderId: number) => {
   const [loading, setLoading] = useState(false)
   const [order, setOrder] = useState<OrderDetailsType | null>(null)
   const [error, setError] = useState<unknown>(null)
   const didFetchRef = useRef(false)

   useEffect(() => {
     if (didFetchRef.current) return
     didFetchRef.current = true

     const fetchDataOrder = async () => {
       try {
         setLoading(true)
         setError(null)

         const data = await orders.getOrder(orderId)
         setOrder(data)
       } catch (err) {
         setError(err)
       } finally {
         setLoading(false)
       }
     }

     fetchDataOrder()
   }, [orderId])

   return { order, loading, error }
}
